import React from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Row,
} from "reactstrap";
// core components
const items = [
  {
    src: require("assets/img/fund.jpeg").default,
    title: "San Antonio, TX",
    title2: "Gabe's memorial fund",
    description:
      "I dont know whats real and not real any more but unfortunately gabe",
    lastdonatehr: "6",
    targetamount: "1000",
    receiveamount: "700",
  },
  {
    src: require("assets/img/fund-2.jpeg").default,
    title: "San Antonio, TX",
    title2: "Gabe's memorial fund",
    description:
      "I dont know whats real and not real any more but unfortunately gabe",
    lastdonatehr: "15",
    targetamount: "1000",
    receiveamount: "500",
  },
  {
    src: require("assets/img/fund-3.jpeg").default,
    title: "San Antonio, TX",
    title2: "Gabe's memorial fund",
    description:
      "I dont know whats real and not real any more but unfortunately gabe",
    lastdonatehr: "9",
    targetamount: "1000",
    receiveamount: "220",
  },
];

function Programs() {
  return (
    <>
      <div className="section section-basic text-center" id="basic-elements">
        <Container>
          <h4 style={{ color: "#45aae5" }}>Be a part of</h4>
          <h2 className="title" style={{ paddingTop: "0px" }}>
            Our Projects
          </h2>
          <p className="px-5 mb-5">
            Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
            consectetur, adipisci velit, sed quia non numquam eius modi tempora
            incidunt ut labore et dolore magnam aliquam.
          </p>
          <Row>
            {items.map((item) => {
              return (
                <div className="col-md-4 col-sm-12">
                  <Card>
                    <img
                      alt="..."
                      className="rounded img-raised"
                      src={item.src}
                    ></img>
                    <CardBody>
                      <CardTitle tag="h4" className="text-uppercase">
                        {item.title}
                      </CardTitle>
                      <CardTitle tag="h5">{item.title2}</CardTitle>
                      <CardText>{item.description}</CardText>
                      <Button className="btn btn-primary">View More</Button>
                    </CardBody>
                  </Card>
                </div>
              );
            })}
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Programs;
